/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import { FormattedMessage } from "react-intl";

/* Helpers, constants, custom methods, internal libraries */

/* Components */

/* Styles */
import styles from "./styles.js"

const Content = props => {
  const { setShowModal } = props;

  const theme = useTheme();
  const classes = styles({ theme });
  return (
    <div className={classes.modalContent}>
      {/* Effective Date */}
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.effectiveDate" />
      </p>

      {/* Section 1: Introduction and Overview */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section1.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section1.content1" />
      </p>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section1.content2" />
      </p>

      {/* Section 2: Tool Use */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2.title" />
      </h2>

      {/* Section 2A: Content */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2A.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2A.content" />
      </p>

      {/* Section 2B: Limited License */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2B.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2B.content" />
      </p>

      {/* Section 2C: Accounts */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2C.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2C.content" />
      </p>

      {/* Section 2D: Restrictions */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2D.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2D.content" />
      </p>

      {/* Section 2E: Availability */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2E.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2E.content" />
      </p>

      {/* Section 2F: Reservation of Rights */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2F.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section2F.content" />
      </p>

      {/* Section 3: Disclaimer */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section3.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section3.content1" />
      </p>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section3.content2" />
      </p>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section3.content3" />
      </p>

      {/* Section 4: Indemnification */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section4.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section4.content" />
      </p>

      {/* Section 5: Customer Support; Notices */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section5.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section5.content" />
      </p>

      {/* Section 6: Third Party Services */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section6.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section6.content" />
      </p>

      {/* Section 7: Choice of Law */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section7.title" />
      </h2>

      {/* Section 7A: Waiver of Class Actions */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section7A.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section7A.content" />
      </p>

      {/* Section 7B: Waiver of Jury Trial */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section7B.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section7B.content" />
      </p>

      {/* Section 8: Waiver of Injunctive or Other Equitable Relief */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section8.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section8.content" />
      </p>

      {/* Section 9: Updates to Terms */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section9.title" />
      </h2>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section9.content" />
      </p>

      {/* Section 10: General Provisions */}
      <h2>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10.title" />
      </h2>

      {/* Section 10A: Consent or Approval */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10A.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10A.content" />
      </p>

      {/* Section 10B: Survival */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10B.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10B.content" />
      </p>

      {/* Section 10C: Severability */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10C.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10C.content" />
      </p>

      {/* Section 10D: Complete Agreement */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10D.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10D.content" />
      </p>

      {/* Section 10E: International Issues */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10E.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10E.content" />
      </p>

      {/* Section 10F: Investigations */}
      <h3>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10F.title" />
      </h3>
      <p>
        <FormattedMessage id="airlineProgram.deltaAirlines.programPage.acceptTerms.modal.section10F.content" />
      </p>
    </div>
  )
}

export default Content;
